




import Vue from 'vue';
import Caret from '@/components/Caret.vue';

export default Vue.extend({
  name: 'NeoInput',
  components: {
    Caret
  },
  props: {
    message: String,
    delay: Number,
  },
  data() {
    return {
      index: 0,
      active: true,
    }
  },
  computed: {
    displayingMessage(): string {
      return this.message.slice(0, this.index);
    },
    isInputting(): boolean {
      return 0 < this.index && this.index < this.message.length;
    },
  },
  methods: {
    delayInput(timeout: number) {
      setTimeout(() => {
        if (this.message.length < this.index + 1)
        {
          setTimeout(this.submit, this.message.length * 200)
          return;
        }

        this.index++;
        this.delayInput(100);
      }, timeout)
    },
    submit() {
      this.active = false;
      this.$emit('submit');
    }
  },
  mounted() {
    this.delayInput(this.delay)
  }
});
